<template>
    <div class="tags" v-if="tags.length > 0" role="list" :aria-label="`Tags: ${tags.join(', ')}`">
        <span 
            v-for="tag in tags" 
            :key="tag" 
            class="tag"
            @click.stop.prevent="handleTagClick(tag)"
            :aria-label="`Tag: ${tag}`"
            role="button"
        >
            {{ tag }}
        </span>
    </div>
</template>

<script>
import menuItemMixin from '../js/mixins/menuItemMixin';
import adaMixin from '../js/mixins/adaMixin';

export default {
    name: 'tags',
    mixins: [menuItemMixin, adaMixin],
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        tags() {
            return this.getTags(this.item);
        }
    },
    methods: {
        handleTagClick(tag) {
            this.setAndClearAnnouncement(tag, 'Tag');
        }
    }
}
</script>

<style scoped>
.tags {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
    font-size: 12px;
    font-weight: 400;
    align-items: center;
    justify-content: flex-start;
    max-width: 300px;
    width: 100%;
}

.tag {
    padding: 6px 10px;
    background-color: #EEEEEF;
    border-radius: 8px;
    cursor: pointer;
    white-space: nowrap;
    flex-shrink: 0;
}

@media (min-width: 577px) {
    .tag {
        cursor: default;
    }
}

@media (max-width: 576px) {
    .tags {
        justify-content: center;
    }
}

.tag-more {
    padding: 6px 10px;
    color: #73A107;
}
</style>